const LocationHeader = 'location';

export function getHeader(headerName: string, headers: Headers): string {
  if (headers) {
    const headerValue = headers.get(headerName);
    return headerValue;
  }

  return null;
}

// Extract the Uuid from the Location Header.
export function getUuidFromLocationHeader(headers: Headers): string {
  const location: string = getHeader(LocationHeader, headers);

  return location;
}
